import io from 'socket.io-client'
import { ENV } from './env'
const socket = io(`${ENV.SOCKET_PORT}`)
// const socket = io(`http://192.168.1.146:8181`)
socket.on('connect', function () { console.log('connect success') })

export default socket